import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-asset-performance',
  templateUrl: './asset-performance.component.html',
  styleUrls: ['./asset-performance.component.css']
})
export class AssetPerformanceComponent implements OnInit {


  isLoading: any = false
  objectInfoList: any = []
  searchFilter: any = ""

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService)
   { }

  ngOnInit(): void {
    this.getAllByAssetMonitoringAndCid(true)
  }

    getAllByAssetMonitoringAndCid(assetMonitoring: any) {
    this.generic_service.getAllByAssetMonitoringAndCid(assetMonitoring).subscribe(
      (response: any) => {
        console.log(response.response)
        let objectInfo: any = []
        for (let list of response.response) {
          if (list.assetMonitoring) {
            objectInfo.push(list)
          }

        }
        this.objectInfoList = objectInfo || []

      },
      (error: any) => {
        console.log(error)
      }
    )
  }


  getAllObjectInfo(){
    this.generic_service.getAllObjectInfo().subscribe(
      (response:any)=>{
        console.log(response.response)

        this.objectInfoList = response.response

      },
      (error:any)=>{
        console.log(error)
      }
    )
  }





  getObjectInfoByWildSearch(){
    if(this.searchFilter == "" || this.searchFilter == null){
      return
    }
    this.generic_service.getObjectInfoByWildSearch(this.searchFilter).subscribe(
      (res: any) => {
        if(res.response == null || res.response.length == 0 || res.response == undefined){
          this.objectInfoList = []
          return

        }
        this.objectInfoList = res.response
      },
      (err: any) => {
        console.log('Serial Number Error:', err);
      }
    );
  }

  refresh(){
    this.searchFilter = ""
    this.getAllObjectInfo()
  }

}
